import { Pipe, PipeTransform} from '@angular/core';
import _ from 'lodash';
import { Util } from '../utils/index';

declare var moment:any;

@Pipe({name: 'dateBetween'})
export class DateBetweenPipe implements PipeTransform {
	
	transform(list: any[], filterByField: string, from:string, to:string): any {
		if (!from && !to) return list;
		
		let fromDt:Date = Util.parseDate(from);
		let toDt:Date = moment(Util.parseDate(to)).add(1, 'day').toDate();
		
		return list.filter(item => {
			if (!fromDt && !toDt) return true;

			const field = item[filterByField];
			const fieldDt:Date = Util.parseDate(field);
			if (!fieldDt) return false;

			if (fromDt && fieldDt.getTime() < fromDt.getTime()) return false;
			if (toDt && fieldDt.getTime() > toDt.getTime()) return false;

			return true;
		});
	}

	

}


// WEBPACK FOOTER //
// ./src/app/pipes/date-between-pipe.ts